import { Path } from '@/main/router/routerPath';

import { CRUMB_LABEL_KEY, REVERSE_JOB_ORDER } from './constants';
import List from './List.vue';


export const router = new Path(REVERSE_JOB_ORDER, { List }, CRUMB_LABEL_KEY);
